module.exports = __webpack_public_path__ + "static/media/gr5-newsletter-3.cb106168.pdf";